import InstallmentTable from './installment-table';

export default InstallmentTable;
